import {Component} from 'substance'

class KeybindingSettings extends Component {

    render($$) {
        return $$('div', null, [
            $$('h3', {class: 'clear'}, [ this.getLabel('keybinding-keyboard-shortcuts') ]),
            $$('div', {class: 'form-group flexible-label'}, [
                $$('button', {class: 'btn sc-np-btn btn-secondary form-control'}, [
                    this.getLabel('keybinding-modify-keyboard-shortcuts')
                ]).on('click', this._openEditor.bind(this))
            ])
        ])
    }

    _openEditor() {
        const {api} = this.context
        api.editorSession.executeCommand('OpenKeybindingEditor', { api })
    }
}

export default KeybindingSettings
